import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import { ActionIcon, ActionIconProps } from "PFComponents/action_icon";

import css from "./action_icons.module.scss";

export type ActionIconData = Omit<ActionIconProps, "onClick" | "color" | "fill"> & {
  onClick: NonNullable<ActionIconProps["onClick"]>;
};

export type ActionIconsProps = {
  actionIcons: ActionIconData[];
  className?: string;
  tabIndex?: number;
};

export const ActionIcons = ({ actionIcons, tabIndex, className }: ActionIconsProps) => {
  if (isEmpty(actionIcons)) {
    return null;
  }

  return (
    <div className={classNames(css.root, className)}>
      {actionIcons.map(({ name, onClick, title, disabled, onMouseDown, ...rest }) => (
        <ActionIcon
          {...rest}
          disabled={disabled}
          key={name}
          name={name}
          tabIndex={tabIndex}
          size="sm"
          onMouseDown={onMouseDown}
          onClick={(event) => {
            event.stopPropagation();
            onClick(event);
          }}
          color="paletteBlue0"
          title={title}
          aria-label={title}
        />
      ))}
    </div>
  );
};
